import {
    ADD_CARD_TO_LIST,
    ARCHIVE_BOARD, CREATE_BOARD, CREATE_BOARD_LIST, DELETE_ATTACHMENT,
    DELETE_BOARD_LIST, DELETE_CHECKLIST, DELETE_CHECKLIST_ITEM, EDIT_BOARD,
    MAKE_COVER, REMOVE_CARD_DATE, RENAME_CHECKLIST, RENAME_CHECKLIST_ITEM, RENAME_LIST,
    SET_ACTIVE_BOARD,
    SET_ACTIVE_CARD, SET_ATTACHMENT,
    SET_BOARD,
    SET_BOARD_LISTS, SET_CARD_CHECKLIST, SET_CARD_CHECKLIST_ITEM, SET_CARD_DATE, SET_CARD_MEMBER, SET_COMMENT,
    SET_DESCRIPTION,
    SET_IS_SHOW_SHARE, SET_SEARCH_BOARDS, TOGGLE_CARD_LABEL,
    TOGGLE_CHECKLIST_ITEM
} from "../../constants";

const initialState = {
    boards: [],
    activeBoard: {},
    boardLists: [],
    archivedBoards: [],
    activeCard: {},
    searchBoards: [],
    isShowShare: false,
};

export const BoardReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_BOARD:
            return {
                ...state,
                boards: action.payload
            };
        case CREATE_BOARD:
            if (state.boards.some((board) => board.id === action.payload.id)) {
                return state;
            }
            return {
                ...state,
                boards: [...state.boards, action.payload]
            }
        case SET_ACTIVE_BOARD:
            return {
                ...state,
                activeBoard: action.payload
            };

        case SET_ACTIVE_CARD:
            return {
                ...state,
                activeCard: action.payload
            };

        case SET_BOARD_LISTS:
            return {
                ...state,
                boardLists: action.payload
            };
        case CREATE_BOARD_LIST:
            return {
                ...state,
                boardLists: state.boardLists.some(
                    (list) => list.id === action.payload.id
                )
                    ? state.boardLists
                    : [...state.boardLists, action.payload]
            };
        case RENAME_LIST:

            return {
                ...state,
                boardLists: state.boardLists.map((list) =>
                    list.id === action.payload.id
                        ? {
                            ...list,
                            title: action.payload.title
                        }
                        : list
                )
            };
        case SET_SEARCH_BOARDS:
            return {
                ...state,
                searchBoards: action.payload
            }
        case ADD_CARD_TO_LIST:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => {

                    if (list.id !== action.payload.listId) {
                        return list;
                    }

                    const exists = (list.cards || []).some(
                        (card) => card.id === action.payload.card.id
                    );

                    if (exists) {
                        return list;
                    }

                    return {
                        ...list,
                        cards: [...(list.cards || []), action.payload.card]
                    };
                })
            };

        case ARCHIVE_BOARD:
            return {
                ...state,
                activeBoard: {
                    ...state.activeBoard,
                    is_archive: action.payload
                }
            };

        case DELETE_BOARD_LIST:
            return {
                ...state,
                boardLists: state.boardLists.filter(
                    (list) => list.id !== action.payload
                )
            };
        case SET_CARD_CHECKLIST:
            return {
                ...state,
                boardLists: state.boardLists.map(list => ({
                    ...list,
                    cards: list.cards.map(card =>
                        card.id === action.payload.card
                            ? {
                                ...card,
                                checklists: [
                                    ...(card.checklists || []),
                                    {
                                        id: action.payload.id,
                                        title: action.payload.title,
                                        items: []
                                    }
                                ]
                            }
                            : card
                    )
                })),

                activeCard:
                    state.activeCard?.id === action.payload.card
                        ? {
                            ...state.activeCard,
                            checklists: [
                                ...(state.activeCard.checklists || []),
                                {
                                    id: action.payload.id,
                                    title: action.payload.title,
                                    items: []
                                }
                            ]
                        }
                        : state.activeCard
            };
        case SET_CARD_DATE:
            return {
                ...state,

                boardLists: state.boardLists.map(list => ({
                    ...list,
                    cards: list.cards.map(card =>
                        card.id === action.payload.card
                            ? {
                                ...card,
                                date: {
                                    id: action.payload.id,
                                    start_date: action.payload.start_date,
                                    due_date: action.payload.due_date
                                }
                            }
                            : card
                    )
                })),

                activeCard:
                    state.activeCard?.id === action.payload.card
                        ? {
                            ...state.activeCard,
                            date: {
                                id: action.payload.id,
                                start_date: action.payload.start_date,
                                due_date: action.payload.due_date
                            }
                        }
                        : state.activeCard
            };
        case SET_CARD_MEMBER: {
            const cardId = Number(action.payload.card_id);
            const userId = Number(action.payload.user_id);

            const updateCardMembers = (card) => {
                if (Number(card.id) !== cardId) {
                    return card;
                }

                const currentMembers = Array.isArray(card.members)
                    ? card.members
                    : [];

                if (action.payload.is_member) {
                    const alreadyExists = currentMembers.some(
                        (member) => Number(member.user_id) === userId
                    );

                    if (alreadyExists) {
                        return card;
                    }

                    return {
                        ...card,
                        members: [
                            ...currentMembers,
                            {
                                id: action.payload.id,
                                card_id: action.payload.card_id,
                                user_id: action.payload.user_id,
                                email: action.payload.email,
                            }
                        ]
                    };
                }

                return {
                    ...card,
                    members: currentMembers.filter(
                        (member) => Number(member.user_id) !== userId
                    )
                };
            };

            return {
                ...state,

                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: list.cards.map((card) => updateCardMembers(card))
                })),

                activeCard: state.activeCard
                    ? updateCardMembers(state.activeCard)
                    : state.activeCard
            };
        }
        case REMOVE_CARD_DATE:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) => ({
                        ...card,
                        date: []
                    }))
                })),

                activeCard: {
                    ...state.activeCard,
                    date: []
                }
            }
        case RENAME_CHECKLIST:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) => ({
                        ...card,
                        checklists: (card.checklists || []).map((checklist) =>
                            checklist.id === action.payload.id
                                ? {...checklist, title: action.payload.title}
                                : checklist
                        ),
                    })),
                })),

                activeCard: {
                    ...state.activeCard,
                    checklists: (state.activeCard.checklists || []).map((checklist) =>
                        checklist.id === action.payload.id
                            ? {...checklist, title: action.payload.title}
                            : checklist
                    ),
                },
            };
        case RENAME_CHECKLIST_ITEM:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) => ({
                        ...card,
                        checklists: (card.checklists || []).map((checklist) => ({
                            ...checklist,
                            items: (checklist.items || []).map((item) =>
                                item.id === action.payload.id
                                    ? {...item, name: action.payload.name}
                                    : item
                            )
                        }))
                    }))
                })),

                activeCard: {
                    ...state.activeCard,
                    checklists: (state.activeCard.checklists || []).map((checklist) => ({
                        ...checklist,
                        items: (checklist.items || []).map((item) =>
                            item.id === action.payload.id
                                ? {...item, name: action.payload.name}
                                : item
                        )
                    }))
                }
            };
        case DELETE_CHECKLIST:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) => ({
                        ...card,
                        checklists: (card.checklists || []).filter((checklist) => checklist.id !== action.payload)
                    }))
                })),

                activeCard: {
                    ...state.activeCard,
                    checklists: (state.activeCard.checklists || []).filter((checklist) => checklist.id !== action.payload)
                }
            }
        case DELETE_CHECKLIST_ITEM:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) => ({
                        ...card,
                        checklists: (card.checklists || []).map((checklist) => ({
                            ...checklist,
                            items: (checklist.items || []).filter(
                                (item) => item.id !== action.payload
                            ),
                        })),
                    })),
                })),

                activeCard: {
                    ...state.activeCard,
                    checklists: (state.activeCard.checklists || []).map((checklist) => ({
                        ...checklist,
                        items: (checklist.items || []).filter(
                            (item) => item.id !== action.payload
                        ),
                    })),
                },
            };
        case SET_CARD_CHECKLIST_ITEM:
            return {
                ...state,
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) => ({
                        ...card,
                        checklists: (card.checklists || []).map((checklist) =>
                            checklist.id === action.payload.checklist
                                ? {
                                    ...checklist,
                                    items: [...(checklist.items || []), action.payload],
                                }
                                : checklist
                        ),
                    })),
                })),

                activeCard: state.activeCard?.id
                    ? {
                        ...state.activeCard,
                        checklists: (state.activeCard.checklists || []).map((checklist) =>
                            checklist.id === action.payload.checklist
                                ? {
                                    ...checklist,
                                    items: [...(checklist.items || []), action.payload],
                                }
                                : checklist
                        ),
                    }
                    : state.activeCard,
            };
        case SET_DESCRIPTION:
            return {
                ...state,

                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: list.cards.map((card) =>
                        Number(card.id) === Number(action.payload.card_id)
                            ? {
                                ...card,
                                description: action.payload.description,
                            }
                            : card
                    ),
                })),

                activeCard:
                    Number(state.activeCard?.id) === Number(action.payload.card_id)
                        ? {
                            ...state.activeCard,
                            description: action.payload.description,
                        }
                        : state.activeCard,
            };
        case SET_ATTACHMENT:
            return {
                ...state,

                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: list.cards.map((card) => {
                        if (card.id !== action.payload.card) return card;

                        const exists = (card.attachments || []).some(
                            (el) => el.id === action.payload.id
                        );

                        if (exists) return card;

                        return {
                            ...card,
                            attachments: [
                                ...(card.attachments || []),
                                {
                                    id: action.payload.id,
                                    file_id: action.payload.file_id,
                                    url: action.payload.url,
                                    title: action.payload.title,
                                    name: action.payload.name,
                                    is_cover: action.payload.is_cover,
                                    created_at: action.payload.created_at,
                                }
                            ]
                        };
                    })
                })),

                activeCard:
                    state.activeCard?.id === action.payload.card
                        ? (() => {
                            const exists = (state.activeCard.attachments || []).some(
                                (el) => el.id === action.payload.id
                            );

                            if (exists) return state.activeCard;

                            return {
                                ...state.activeCard,
                                attachments: [
                                    ...(state.activeCard.attachments || []),
                                    {
                                        id: action.payload.id,
                                        file_id: action.payload.file_id,
                                        url: action.payload.url,
                                        title: action.payload.title,
                                        name: action.payload.name,
                                        is_cover: action.payload.is_cover,
                                        created_at: action.payload.created_at,
                                    }
                                ]
                            };
                        })()
                        : state.activeCard
            };

        case SET_COMMENT:
            return {
                ...state,

                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: list.cards.map((card) => {
                        if (String(card.id) !== String(action.payload.card_id)) {
                            return card;
                        }

                        const exists = (card.comments || []).some(
                            (comment) => String(comment.id) === String(action.payload.id)
                        );

                        if (exists) {
                            return card;
                        }

                        return {
                            ...card,
                            comments: [
                                action.payload,
                                ...(card.comments || []),
                            ],
                        };
                    }),
                })),

                activeCard:
                    String(state.activeCard?.id) === String(action.payload.card_id)
                        ? (() => {
                            const exists = (state.activeCard.comments || []).some(
                                (comment) => String(comment.id) === String(action.payload.id)
                            );

                            if (exists) {
                                return state.activeCard;
                            }

                            return {
                                ...state.activeCard,
                                comments: [
                                    action.payload,
                                    ...(state.activeCard.comments || []),
                                ],
                            };
                        })()
                        : state.activeCard,
            };
        case MAKE_COVER:
            return {
                ...state,

                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: list.cards.map((card) => {
                        if (card.id !== action.payload.cardId) return card;

                        return {
                            ...card,
                            attachments: (card.attachments || []).map((attachment) => ({
                                ...attachment,
                                is_cover: attachment.id === action.payload.newId
                            }))
                        };
                    })
                })),

                activeCard:
                    state.activeCard?.id === action.payload.cardId
                        ? {
                            ...state.activeCard,
                            attachments: (state.activeCard.attachments || []).map((attachment) => ({
                                ...attachment,
                                is_cover: attachment.id === action.payload.newId
                            }))
                        }
                        : state.activeCard
            };
        case DELETE_ATTACHMENT:
            return {
                ...state,

                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: list.cards.map((card) => ({
                        ...card,
                        attachments: (card.attachments || []).filter(
                            (el) => el.id !== action.payload
                        )
                    }))
                })),

                activeCard: {
                    ...state.activeCard,
                    attachments: (state.activeCard?.attachments || []).filter(
                        (el) => el.id !== action.payload
                    )
                }
            };
        case TOGGLE_CARD_LABEL: {
            const {label, is_checked} = action.payload;

            let updatedActiveLabels = [...(state.activeCard.labels || [])];

            if (is_checked) {
                const exists = updatedActiveLabels.some(
                    (item) => item.label_id === label.id
                );

                if (!exists) {
                    updatedActiveLabels.push({
                        id: label.id,
                        label_id: label.id,
                        card: state.activeCard.id,
                        color: label.color,
                        name: label.name,
                        is_checked: true
                    });
                }
            } else {
                updatedActiveLabels = updatedActiveLabels.filter(
                    (item) => item.label_id !== label.id
                );
            }

            return {
                ...state,
                activeCard: {
                    ...state.activeCard,
                    labels: updatedActiveLabels
                },
                boardLists: state.boardLists.map((list) => ({
                    ...list,
                    cards: (list.cards || []).map((card) =>
                        card.id === state.activeCard.id
                            ? {
                                ...card,
                                labels: updatedActiveLabels
                            }
                            : card
                    )
                }))
            };
        }
        case TOGGLE_CHECKLIST_ITEM:
            return {
                ...state,
                activeCard: {
                    ...state.activeCard,
                    checklists: (state.activeCard?.checklists || []).map((cl) =>
                        cl.id === action.payload.checklistId
                            ? {
                                ...cl,
                                items: (cl.items || []).map((item) =>
                                    item.id === action.payload.itemId
                                        ? {
                                            ...item,
                                            is_checked: action.payload.value
                                        }
                                        : item
                                )
                            }
                            : cl
                    )
                }
            };
        case EDIT_BOARD:
            return {
                ...state,
                activeBoard: {
                    ...state.activeBoard,
                    object_id: action.payload.object_id,
                    path: action.payload.path,
                    name: action.payload.name
                }
            }
        case SET_IS_SHOW_SHARE:
            return {
                ...state,
                isShowShare: action.payload
            }
        default:
            return state;
    }
};
